<template>
  <div class="picker-main disable-selection">
    <div v-if="isDisabled" class="disable-block"></div>
    <div><span v-if="isRequired" style="color: red; margin-right: 3px; font-size: 10px">**</span>{{ title }}: </div>
    <div class="date-time-box" tabindex="1" @focus="onFocus()" @blur="onBlur()" ref="mainBox" :style="{ borderColor: isDisabled ? 'rgb(200,200,200)' : 'black' }">
      <div class="date-time">
        <input type="number" placeholder="dd" v-model="dateInput" ref="dayIn" :disabled="isDisabled">
        <div>/</div>
        <input type="number" placeholder="MM" v-model="monthInput" ref="monthIn" :disabled="isDisabled">
        <div>/</div>
        <input type="number" style="width: 2.5em; margin-right: 5px" placeholder="yyyy" v-model="yearInput" ref="yearIn" :disabled="isDisabled">
        
        <input type="number" placeholder="00" v-model="hourInput" ref="hourIn" :disabled="isDisabled" v-if="showTime">
        <div v-if="showTime">:</div>
        <input type="number" placeholder="00" v-model="minInput" ref="minuteIn" :disabled="isDisabled" v-if="showTime">
      </div>
      <div class="close-btn" :style="{ borderColor: isDisabled ? 'rgb(200,200,200) transparent transparent transparent' : 'black transparent transparent transparent' }"></div>
      
      <div v-if="showCalendar" class="calendar">
        <Help class="help" title="Date and Time Picker" :helpItems="howToUse" @helpOpened="helpStatus"/>

        <div class="today-dot" @click="todayClick()"></div>
        <div class="year">
          <div class="previous" @click="previousNextClick(false, false)">&lt;</div>
          {{ year }}
          <div class="next" @click="previousNextClick(false, true)">&gt;</div>
        </div>
        <div class="month">
          <div class="previous" @click="previousNextClick(true, false)">&lt;</div>
          {{ fullMonth[month] }}
          <div class="next" @click="previousNextClick(true, true)">&gt;</div>
        </div>

        <div class="days-section">
          <div v-for="(d, i) in shortDays" :key="`${d}${i}sDays`" class="short-days">{{ d }}</div>
          <div v-for="(a, ind) in allDates" :key="`d${a}i${ind}aDates`" :class="getDateClass(a)" @click="dateClick(this, a)">{{ a }}</div>
        </div>

        <div v-if="showTime" class="time-section">
          <div tabindex="1" @keydown="hourKeydown" @blur="hourMinBlur()" ref="hourBox">{{ hour }}</div>
          <div>:</div>
          <div tabindex="2" @keydown="minKeydown" @blur="hourMinBlur()" ref="minBox">{{ min }}</div>
        </div>  
      </div>
    </div>

    <div v-if="errorMessage" class="error-box" :style="{ justifyContent: placeholderAlign }"
      @click="setFocus()">
      <div class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Help from '@/components/HowToUse.vue';

var helpOpened = false;
var dontChange = false;

export default {
  components: {
    Help
  },
  data: function() {
    return {
      year: 0,
      month: 0,
      allDates: [],
      showCalendar: false,
      shortDays: [ 'S', 'M', 'T', 'W', 'T', 'F', 'S' ],
      selectedDate: 'dd/MM/yyyy',
      hour: '--',
      min: '--',
      selectedTime: '--:--',
      pValue: null,
      dateInput: null,
      monthInput: null,
      yearInput: null,
      hourInput: null,
      minInput: null
    }
  },
  props: {
    showHelp: { type: Boolean, default: false },

    fullMonth: { type: Array, default: function() { return [
      'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
    ] } },

    howToUse: { type: Array, default: function() { return [
      { img: 'datetimepickerhelp/1.png', caption: `Calendar will load the current year and month by default.
      Change the year or month by clicking on the '<' or '>'.` },
      { img: 'datetimepickerhelp/2.png', caption: `The dates that are in light gray is disabled and not selectable.` },
      { img: 'datetimepickerhelp/3.png', caption: `Click your desired date, and the selected date will be in blue color.` },
      { img: 'datetimepickerhelp/4.png', caption: `Once date is picked, you can select your desired time using the up and down arrow keys.
      Use Tab key or click to focus on the hour/minute to change the time.
      Focused hour/minute will have a black border around it.` },
    ] }},
    
    //Public props
    value: { type: Date, default: function() { return null } },
    showTime: { type: Boolean, default: true },
    defaultTime: { type: String, default: '00:00' },
    // minDate: { type: Date, default: new Date(2019, 10, 15) },
    // maxDate: { type: Date, default: new Date(2019, 10, 28) }
    maxDate: { type: Date, default: function() { return null } },
    minDate: { type: Date, default: function() { return null } },
    isDisabled: { type: Boolean, default: false },
    title: { type: String, default: '' },
    errorMessage: { type: String, default: '' },
    isRequired: { type: Boolean, default: false },
  },
  methods: {
    populateCalendar: function() {
      this.allDates = [];

      var thisMonth = new Date(this.year, this.month, 1);
      var totalDays = new Date(this.year, this.month + 1, 0).getDate();

      // alert(thisMonth);

      for (var i = 0; i < thisMonth.getDay(); i++) {
        this.allDates.push('');
      }

      for (var j = 1; j <= totalDays; j++) {
        this.allDates.push(`${j}`);
      }

      var diff = this.allDates.length % 7;

      if (diff > 0) {
        for (var k = 0; k < (7 - diff); k++) {
          this.allDates.push('');
        }
      }
    },
    previousNextClick: function(month, next) {
      if (month == true) {
        if (next == true) {
          this.month++;
          if (this.month > 11) {
            this.year++;
            this.month = 0;
          }
        } else {
          this.month--;
          if (this.month < 0) {
            this.year--;
            this.month = 11;
          }
        }
      } else {
        if (next == true) {
          this.year++;
        } else {
          this.year--;
        }
      }

      this.populateCalendar();
    },
    getDateClass: function(day) {   
      if (day == '') {
        return 'empty-dates';
      }
      var dayPadded = day.length == 1 ? `0${day}` : day;
      var monthPadded = (this.month + 1) < 10 ? `0${(this.month + 1)}` : `${(this.month + 1)}`;
      var currentDate = `${dayPadded}/${monthPadded}/${this.year}`;
      
      if (currentDate == this.$dateTime.getDateTime(new Date(), 'dd/MM/yyyy') && currentDate == this.selectedDate) { // Date is today's date and selected date
        return 'dates today-date date-selected';
      } else if (currentDate == this.$dateTime.getDateTime(new Date(), 'dd/MM/yyyy')) { // Date is today's date
        if ((this.minDate != null && this.$dateTime.stringToDate(currentDate, '/') < this.minDate) || (this.maxDate != null && this.$dateTime.stringToDate(currentDate, '/') > this.maxDate)) {
          return 'dates today-date disable-date';
        } else {
          return 'dates today-date';
        }
      } else if (currentDate == this.selectedDate) { // Date is selected date
        return 'dates date-selected';
      } else if ((this.minDate != null && this.$dateTime.stringToDate(currentDate, '/') < this.minDate) || (this.maxDate != null && this.$dateTime.stringToDate(currentDate, '/') > this.maxDate)) {
        return 'empty-dates disable-date';
      } else { // All other dates
        return 'dates';
      }
    },
    dateClick: function(el, date) {
      if (date) {
        var dayPadded = date.length == 1 ? `0${date}` : date;
        var monthPadded = (this.month + 1) < 10 ? `0${(this.month + 1)}` : `${(this.month + 1)}`;
        var selected = `${dayPadded}/${monthPadded}/${this.year}`;

        if ((this.minDate != null && this.$dateTime.stringToDate(selected, '/') < this.minDate) || (this.maxDate != null && this.$dateTime.stringToDate(selected, '/') > this.maxDate)) {
          return;
        }

        this.selectedDate = selected;
        
        if (!this.showTime) {
          this.selectedTime = '00:00';
        } else if (this.hour == '--') {
          this.hour = this.defaultTime.split(':')[0];
          this.min = this.defaultTime.split(':')[1];
          this.selectedTime = `${this.hour}:${this.min}`;
        }
        
        this.pValue = this.$dateTime.stringToDate(`${this.selectedDate} ${this.selectedTime}`, '/');
        this.$emit('update:value', this.pValue);

        if (this.showTime) {
          this.$refs.hourBox.focus();
        }
      }
    },
    hourKeydown: function(e) {
      if (this.hour == '--') {
        this.hour = '00';
      }

      var hr = parseInt(this.hour);

      if (e.key == 'ArrowUp') {
        e.preventDefault();
        hr++;
        if (hr > 23) {
          hr = 0;
        }
      } else if (e.key == "ArrowDown") {
        e.preventDefault();
        hr--;
        if (hr < 0) { 
          hr = 23;
        }
      }

      this.hour = hr < 10 ? `0${hr}` : hr;
      this.selectedTime = `${this.hour}:${this.min}`;

      this.pValue = this.$dateTime.stringToDate(`${this.selectedDate} ${this.selectedTime}`, '/');
      this.$emit('update:value', this.pValue);
    }, 
    minKeydown: function(e) {
      if (this.min == '--') {
        this.min = '00';
      }

      var mi = parseInt(this.min);

      if (e.key == 'ArrowUp') {
        e.preventDefault();
        mi++;
        if (mi > 59) {
          mi = 0;
        }
      } else if (e.key == "ArrowDown") {
        e.preventDefault();
        mi--;
        if (mi < 0) { 
          mi = 59;
        }
      }

      this.min = mi < 10 ? `0${mi}` : mi;
      this.selectedTime = `${this.hour}:${this.min}`;
      
      this.pValue = this.$dateTime.stringToDate(`${this.selectedDate} ${this.selectedTime}`, '/');
      // alert(this.pValue);
      this.$emit('update:value', this.pValue);
    },
    onBlur: function() {
      if (helpOpened == true) {
        return;
      } else if (document.activeElement == this.$refs.dayIn || document.activeElement == this.$refs.monthIn ||
              document.activeElement == this.$refs.yearIn || document.activeElement == this.$refs.hourIn ||
              document.activeElement == this.$refs.minuteIn) {
        setTimeout(() => {
          return
        }, 1);
      } else {
        setTimeout(() => {
          if (document.activeElement == this.$refs.hourBox || document.activeElement == this.$refs.minBox) {
            return;
          } else {
            this.showCalendar = false;
          }
        }, 1);
      }
    },
    onFocus: function() {
      this.showCalendar = true;
    },
    hourMinBlur: function() {
      setTimeout(() => {
        if (document.activeElement == this.$refs.hourBox || document.activeElement == this.$refs.minBox || document.activeElement == this.$refs.mainBox) {
          return;
        } else {
          this.showCalendar = false;
        }
      }, 1);
    },
    helpStatus: function(status) {
      helpOpened = status;
    },
    todayClick: function() {
      if (this.minDate || this.maxDate) {
        if (new Date() < this.minDate || new Date() > this.maxDate) {
          return;
        }
      }

      this.pValue = new Date();

      this.selectedDate = this.$dateTime.getDateTime(this.pValue, 'dd/MM/yyyy');
      this.selectedTime = this.$dateTime.getDateTime(this.pValue, 'HH:mm');

      this.hour = this.$dateTime.getDateTime(this.pValue, 'HH');
      this.min = this.$dateTime.getDateTime(this.pValue, 'mm');

      this.month = this.pValue.getMonth();
      this.year = this.pValue.getFullYear();

      this.populateCalendar();

      this.$emit('update:value', this.pValue);
    },
    topDivClicked: function() {
      alert('a');
    },
    setFocus: function() {
      this.errorMessage = '';
      this.$emit('update:errorMessage', this.errorMessage);

      this.$refs.dayIn.focus();
    }
  },
  watch: {
    dateInput: function(val) {
      if (this.showCalendar || dontChange) return;

      if (val.length >= 2) {
        this.$refs.monthIn.focus();
        this.$refs.monthIn.select();
        if (parseInt(val) > 31) {
          this.dateInput = '31';
        } else if (val <= 0) {
          this.dateInput = '01';
        }

        this.selectedDate = `${this.dateInput}/${this.monthInput}/${this.yearInput}`;
      } else {
        this.pValue = null;
      }
    },
    monthInput: function(val) {
      if (this.showCalendar || dontChange) return;

      if (val.length >= 2) {
        this.$refs.yearIn.focus();
        this.$refs.yearIn.select();
        if (parseInt(val) > 12) {
          this.monthInput = '12';
        } else if (parseInt(val) <= 0) {
          this.monthInput = '01';
        }

        if (this.monthInput == '04' || this.monthInput == '06' || this.monthInput == '09' || this.monthInput == '11') {
          if (parseInt(this.dateInput) > 30) {
            this.dateInput = '30';
          }
        } else if (this.monthInput == '02') {
          if (parseInt(this.dateInput) > 29) {
            this.dateInput = '29';
          }
        }

        this.selectedDate = `${this.dateInput}/${this.monthInput}/${this.yearInput}`;
      } else {
        this.pValue = null;
      }
    },
    yearInput: function(val) {
      if (this.showCalendar || dontChange) return;

      if (val.length >= 4) {
        if (this.showTime) {
          this.$refs.hourIn.focus();
          this.$refs.hourIn.select();
        }

        if (parseInt(val) > 2100) {
          this.yearInput = this.$dateTime.getDateTime(new Date(), 'yyyy');
        } else if (parseInt(val) < 1970) {
          this.yearInput = this.$dateTime.getDateTime(new Date(), 'yyyy');
        }

        if (this.monthInput == '02') {
          var days = new Date(parseInt(this.yearInput), this.monthInput, 0).getDate();
          if (parseInt(this.dateInput) > days) {
            this.dateInput = days.toString();
          }
        }

        this.selectedDate = `${this.dateInput}/${this.monthInput}/${this.yearInput}`;
      } else {
        this.pValue = null;
      }
    },
    hourInput: function(val) {
      if (this.showCalendar || dontChange) return;

      if (val.length >= 2) {
        this.$refs.minuteIn.focus();
        this.$refs.minuteIn.select();
        if (parseInt(val) > 23) {
          this.hourInput = '23';
        } else if (parseInt(val) < 0) {
          this.hourInput = '00';
        }

        this.hour = this.hourInput;

        this.selectedTime = `${this.hourInput}:${this.minInput}`;
      } else {
        this.pValue = null;
      }
    },
    minInput: function(val) {
      if (this.showCalendar || dontChange) return;

      if (val.length >= 2) {
        this.$refs.minuteIn.blur();
        if (parseInt(val) > 59) {
          this.minInput = '59';
        } else if (parseInt(val) < 0) {
          this.minInput = '00';
        }

        this.min = this.minInput;

        this.selectedTime = `${this.hourInput}:${this.minInput}`;

        this.pValue = this.$dateTime.stringToDate(`${this.selectedDate} ${this.selectedTime}`, '/');

        this.year = this.pValue.getFullYear();
        this.month = this.pValue.getMonth();

        this.populateCalendar();
      } else {
        this.pValue = null;
      }
    },
    selectedDate: function(val) {
      var dayMonthYear = val.split('/');

      dontChange = true;
      this.dateInput = dayMonthYear[0];
      this.monthInput = dayMonthYear[1];
      this.yearInput = dayMonthYear[2];
      setTimeout(() => {
        dontChange = false;
      }, 10);

      if (parseInt(this.dateInput) > 0 && parseInt(this.monthInput) > 0 && parseInt(this.yearInput) > 0) {
        if (this.showTime) {
          if (this.selectedTime != '--:--') {
            this.pValue = this.$dateTime.stringToDate(`${val} ${this.selectedTime}`, '/');
          }
        } else {
          this.pValue = this.$dateTime.stringToDate(`${val} 00:00`, '/');
        }
      }
    },
    selectedTime: function(val) {
      var hourMin = val.split(':');

      dontChange = true;
      this.hourInput = hourMin[0];
      this.minInput = hourMin[1];
      setTimeout(() => {
        dontChange = false;
      }, 10);

      if (parseInt(this.hourInput) >= 0 && parseInt(this.minInput) >= 0) {
        this.pValue = this.$dateTime.stringToDate(`${this.selectedDate} ${val}`, '/');
      }
    },
    pValue: function(val) {
      this.$emit('update:value', val);
      if (val != null) {
        this.year = val.getFullYear();
        this.month = val.getMonth();

        this.hour = val.getHours() < 10 ? `0${val.getHours()}` : val.getHours();
        this.min = val.getMinutes() < 10 ? `0${val.getMinutes()}` : val.getMinutes();
        
        this.selectedDate = this.$dateTime.getDateTime(val, 'dd/MM/yyyy');
        if (this.showTime) {
          this.selectedTime = this.$dateTime.getDateTime(val, 'HH:mm');
        }
      } else {
        // this.dateInput = null;
        // this.monthInput = null;
        // this.yearInput = null;
        // this.hourInput = null;
        // this.minInput = null;

        // this.selectedDate = 'dd/MM/yyyy';
        // this.selectedTime = '--:--';

        this.year = new Date().getFullYear();
        this.month = new Date().getMonth();
      }

      this.populateCalendar();
    },
    value: function(val) {
      this.pValue = val;
      if (!val) {
        this['dateInput'] = null;
        this['monthInput'] = null;
        this['yearInput'] = null;
        
        if (this.showTime) {
          this['hourInput'] = null;
          this['minInput'] = null;
        }
      }
    }
  },
  mounted() {
    if (this.value != null) {
      this.pValue = this.value;
      this.year = this.pValue.getFullYear();
      this.month = this.pValue.getMonth();

      this.hour = this.pValue.getHours() < 10 ? `0${this.pValue.getHours()}` : this.pValue.getHours();
      this.min = this.pValue.getMinutes() < 10 ? `0${this.pValue.getMinutes()}` : this.pValue.getMinutes();
      
      this.selectedDate = this.$dateTime.getDateTime(this.pValue, 'dd/MM/yyyy');
      this.selectedTime = this.$dateTime.getDateTime(this.pValue, 'HH:mm');
    } else {
      this.year = new Date().getFullYear();
      this.month = new Date().getMonth();
    }

    this.populateCalendar();
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.picker-main {
  display: flex;
  // justify-content: center;
  height: 25px;
  font-size: 12px;
  position: relative;
  margin: 2px 0;
  align-items: center;
  top: -3px;
  // width: 100%;
  // background-color: yellow;
}

.date-time-box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  // border: 1px solid black;
  // border-radius: 10px;
  border-style: solid;
  border-color: rgb(200,200,200);
  border-width: 0 0 1px 0;
  margin-left: 5px;
  // padding: 8px 5px 2px 5px;
  // padding: 5px;
}

.top-div {
  position: absolute;
  background-color: red;
  opacity: 0.5;
  width: 100%;
  height: 100%;
}

.date-time-box:focus {
  outline: none;
}

.date-time {
  display: flex;
}

.date-time input {
  width: 1.5em;
  text-align: center;
  border: none;
  padding: 0;
  // border-color: black;
  // border-width: 0 0 1px 0;
  // border-style: solid;
}

.date-time input::-webkit-outer-spin-button, .date-time input::-webkit-inner-spin-button {
  display: none;
}

.date-time input::placeholder {
  opacity: 0.3;
}

.date-time input:disabled {
  border-color: transparent;
  background-color: transparent;
}

.date-time:hover, .previous:hover, .next:hover {
  cursor: pointer;
}

.close-btn {
  border-color: black transparent transparent transparent;
  border-width: 5px 5px 0px 5px;
  border-style: solid;
  height: 0;
  margin-left: 5px;
}

// Region Calendar Area
.calendar {
  position: absolute;
  top: calc(100% + 1px);
  width: 100%;
  min-width: 176px;
  padding: 5px;
  background-color: white;
  border: 1px solid black;
  border-radius: 5px;
  user-select: none;
  z-index: 999;
}

.calendar .month, .year {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.previous {
  position: absolute;
  left: 10px;
}

.next {
  position: absolute;
  right: 10px;
}

.calendar .days-section {
  // background-color: red;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.days-section .dates, .days-section .short-days, .empty-dates {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8em;
  height: 20px;
  width: 20px;
  background-color: white;
  border: 1px solid transparent;
  margin: 1px;
  transition: $transition-time;
}

.disable-date {
  background-color: rgba(64,64,64,0.2) !important;
  border-radius: 100%;
}

.today-date {
  border: 1px solid black !important;
  border-radius: 0 !important;
}

.date-selected {
  background-color: blue !important;
  border-radius: 100%;
  color: white;
}

.time-section {
  display: flex;
  justify-content: center;
}

.time-section div:focus {
  outline: none;
  border: 1px solid black;
  border-radius: 5px;
}

.dates:hover {
  cursor: pointer;
  background-color: blue;
  border-radius: 100%;
  color: white;
}

.today-dot {
  height: 15px;
  width: 15px;
  background: linear-gradient(transparent, gray);
  border: 1px solid gray;
  position: absolute;
  border-radius: 100%;
  bottom: 5px;
  transform: rotate(20deg);
  cursor: pointer;
}

.disable-block {
  opacity: 0.8;
  background-color: rgba(200,200,200,0.3);
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 1;
}


// End Region Calendar Area

.help {
  position: absolute;
  bottom: 0;
  right: 0;
}

.error-box {
  position: absolute;
  width: 100%;
  display: flex;
  align-items: center;
  height: 100%;
  cursor: text;
  font-size: 12px;
  top: -2px;
  left: 0px;
}

.error-message {
  background-color: red;
  color: white;
  padding: 1px 5px;
  border-radius: 5px;
  white-space: nowrap;
  overflow: hidden;
  margin-right: 20px;
  text-overflow: ellipsis;
}
</style>